export function parseJwt(token) {
    if (!token) return Error('JWT Token must be provided');
    const payload = token.split('.')[1];
    if (!payload) return Error('JWT Token must have a Payload');
    const jwt = window.atob(payload.replace('-', '+').replace('_', '/'));
    return JSON.parse(jwt);
}
